import { ref } from 'vue'

/**
 * The task the request on screen was made from.
 *
 * Almost every field of a request's details belongs to its task, and the details block
 * is what fetches it - but a save answers with the request alone, and the layout puts
 * that answer in the form's place. Kept here, the task can be folded back in, so saving
 * a request does not blank everything the task contributed.
 *
 * Module level, for the same reason `useRequestAbnormality` is: the block that writes it
 * and the tab config that reads it live in separate trees, and there is only ever one
 * request details screen open.
 */
const task = ref(null)

export function useRequestTask () {
  const setRequestTask = (value) => {
    task.value = value || null
  }

  const getRequestTask = () => task.value

  const clearRequestTask = () => {
    task.value = null
  }

  return {
    setRequestTask,
    getRequestTask,
    clearRequestTask
  }
}
